// extracted by mini-css-extract-plugin
module.exports = {"scroll":"HideScrollbar_scroll__vVh1r"};